"use client";

import type { HeaderNavAction } from "@lib/types";
import Link from "next/link";

import { resolveCtaHref } from "@/components/shared/cta";
import { Button, type ButtonProps } from "@/components/ui/button";

type HeaderActionButtonProps = {
  action?: HeaderNavAction | null;
  fallbackVariant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  className?: string;
  onClick?: () => void;
};

export function HeaderActionButton({
  action,
  fallbackVariant = "primary",
  size = "sm",
  className,
  onClick,
}: HeaderActionButtonProps) {
  if (!action?.label) {
    return null;
  }

  const variant = (action.variant ?? fallbackVariant) as ButtonProps["variant"];
  const href = resolveCtaHref(action.href);
  if (!href || href === "#") {
    return null;
  }
  const isExternal = action.openInNewTab || /^https?:\/\//i.test(href);

  return (
    <Button asChild variant={variant} size={size} className={className}>
      <Link
        href={href}
        target={isExternal ? "_blank" : undefined}
        rel={isExternal ? "noreferrer noopener" : undefined}
        onClick={onClick}
      >
        {action.label}
      </Link>
    </Button>
  );
}
